var moment = require("moment");
var CurrentUser = require("lib/account/CurrentUser");
var CustomerIOClient = require("lib/integrations/CustomerIOClient");

require("support/webinar_registration.scss");

class WebinarRegistration extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { selectedWebinar: this.upcomingWebinars()[0] };
	}

	selectWebinar(webinarData) {
		this.setState({ selectedWebinar: webinarData });
	}

	register() {
		CustomerIOClient.event(CurrentUser.get(), "registered-for-webinar", this.state.selectedWebinar);
		Mycroft.newEvent({ category: "Paywall", action: "webinar-signup", label: this.props.sourceFeature });
		window.wrNotifications.triggerDropDownNotification({
			title: "Registration Complete!", text: "Check your email for details.", icon: "ok-sign" });
	}

	upcomingWebinars() {
		return _.filter(SCHEDULED_WEBINARS, (webinarData) => {
			return moment().isBefore(webinarData.dateTime);
		}).slice(0, 2);
	}

	renderDateTimeOption(webinarData, index) {
		var currentlySelected = webinarData.dateTime == this.state.selectedWebinar.dateTime;

		return (
			<label className="formOption" key={ webinarData.dateTime }>
				<input type="radio" checked={ currentlySelected }
					onChange={ this.selectWebinar.bind(this, webinarData) } />
				<span>{ webinarData.dateText } at { webinarData.timeText }</span>
			</label>
		);
	}

	render() {
		var webinarOptions = _.map(this.upcomingWebinars(), (webinarData, index) => {
			return this.renderDateTimeOption(webinarData, index);
		});

		return (
			<div className="webinarRegistration">
				<p>
					Select the time that works best for you and we will email you instructions
					on how to join the webinar.
				</p>
				<button className="btn buttonSuccess" onClick={ this.register }>
					Save My Spot!
				</button>
				{ webinarOptions }
			</div>
		);
	}

}

var SCHEDULED_WEBINARS = [
	{ dateText: "August 15 (Wednesday)", timeText: "11:00am PDT", dateTime: "2018-08-15 11:00-07:00" },
	{ dateText: "August 23 (Thursday)", timeText: "3:00pm PDT", dateTime: "2018-08-23 15:00-07:00" },
	{ dateText: "August 28 (Tuesday)", timeText: "9:00am PDT", dateTime: "2018-08-28 09:00-07:00" },
	{ dateText: "September 5 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-09-05 15:00-07:00" },
	{ dateText: "September 13 (Thursday)", timeText: "9:00am PDT", dateTime: "2018-09-13 09:00-07:00" },
	{ dateText: "September 18 (Tuesday)", timeText: "11:00am PDT", dateTime: "2018-09-18 11:00-07:00" },
	{ dateText: "September 26 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-09-26 09:00-07:00" },
	{ dateText: "October 4 (Thursday)", timeText: "11:00am PDT", dateTime: "2018-10-04 11:00-07:00" },
	{ dateText: "October 9 (Tuesday)", timeText: "3:00pm PDT", dateTime: "2018-10-09 15:00-07:00" },
	{ dateText: "October 11 (Thursday)", timeText: "11:00am PDT", dateTime: "2018-10-11 11:00-07:00" },
	{ dateText: "October 16 (Tuesday)", timeText: "3:00pm PDT", dateTime: "2018-10-16 15:00-07:00" },
	{ dateText: "October 31 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-10-31 15:00-07:00" },
	{ dateText: "November 14 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-11-14 09:00-07:00" },
	{ dateText: "November 28 (Wednesday)", timeText: "3:00pm PDT", dateTime: "2018-11-28 15:00-07:00" },
	{ dateText: "December 12 (Wednesday)", timeText: "9:00am PDT", dateTime: "2018-12-12 09:00-07:00" }
];

WebinarRegistration.propTypes = PageStrictPropTypes({
	// to record which location the registration came from
	sourceFeature: PropTypes.string.isRequired
});

module.exports = WebinarRegistration;


// WEBPACK FOOTER //
// ./modules/components/support/WebinarRegistration.js